/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DisconnectDeviceRequestModel } from '../../models/disconnect-device-request-model';
import { PlatformType } from '../../models/platform-type';
import { SessionConfigResponseModel } from '../../models/session-config-response-model';

export interface ProfileVivaConnectDisconnectPlatformPost$Params {

/**
 * Target platform (iOS or Android).
 */
  platform: PlatformType;
  
    /**
     * Device disconnection request.
     */
    body?: DisconnectDeviceRequestModel
}

export function profileVivaConnectDisconnectPlatformPost(http: HttpClient, rootUrl: string, params: ProfileVivaConnectDisconnectPlatformPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<SessionConfigResponseModel>> {
  const rb = new RequestBuilder(rootUrl, profileVivaConnectDisconnectPlatformPost.PATH, 'post');
  if (params) {
    rb.path('platform', params.platform, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<SessionConfigResponseModel>;
    })
  );
}

profileVivaConnectDisconnectPlatformPost.PATH = '/Profile/VivaConnectDisconnect/{platform}';
